var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vb-confirm-view"},[_c('b-container',[(_vm.loading)?_c('section',{staticClass:"section section--loader"},[_c('loader',{attrs:{"size":"large","show_timing_slot":true}})],1):_vm._e(),(!_vm.loading)?_c('section',{staticClass:"section"},[_c('confirm',{attrs:{"data":_vm.confirm}})],1):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }